import type { SVGProps } from 'react';

export function CatIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M3.6 6a3.6 3.6 0 0 1 3.6 3.6v3.218a7.22 7.22 0 0 1 5.003-3.15A6.3 6.3 0 0 0 19.2 13.38v7.02c0 .664-.536 1.2-1.2 1.2s-1.2-.536-1.2-1.2v-5.28l-5.1 4.08h2.1c.664 0 1.2.536 1.2 1.2s-.536 1.2-1.2 1.2H8.4A3.6 3.6 0 0 1 4.8 18V9.6c0-.622-.472-1.132-1.076-1.192l-.248-.012A1.204 1.204 0 0 1 2.4 7.2c0-.664.536-1.2 1.2-1.2m17.618-3.48a.599.599 0 0 1 .982.461V7.2c0 2.321-1.879 4.2-4.2 4.2a4.2 4.2 0 0 1-4.2-4.2V2.981c0-.51.592-.787.982-.461L16.8 4.2h2.4zM16.2 6.45a.75.75 0 0 0-.75.75c0 .413.338.75.75.75.413 0 .75-.337.75-.75a.75.75 0 0 0-.75-.75m3.6 0a.75.75 0 0 0-.75.75c0 .413.337.75.75.75.412 0 .75-.337.75-.75a.75.75 0 0 0-.75-.75" />
    </svg>
  );
}
